import { render, staticRenderFns } from "./FishDetailCard.vue?vue&type=template&id=482a5d49&scoped=true&"
import script from "./FishDetailCard.vue?vue&type=script&lang=js&"
export * from "./FishDetailCard.vue?vue&type=script&lang=js&"
import style0 from "./FishDetailCard.vue?vue&type=style&index=0&id=482a5d49&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482a5d49",
  null
  
)

export default component.exports